var map = {
	"./landing-page-en/feature-1_2x.png": [
		10990,
		6135
	],
	"./landing-page-en/feature-2_2x.png": [
		30765,
		9884
	],
	"./landing-page-en/feature-3_2x.png": [
		84059,
		5794
	],
	"./landing-page-pt/feature-1_2x.png": [
		29755,
		261
	],
	"./landing-page-pt/feature-2_2x.png": [
		92980,
		4944
	],
	"./landing-page-pt/feature-3_2x.png": [
		47376,
		4267
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94681;
module.exports = webpackAsyncContext;